import { brand, channelGroups, channels, faqs } from "@/mocks/homeData";

export default function StructuredData() {
  const graph = [
    {
      "@type": "Organization",
      "@id": "https://cdtianxin.cn/#organization",
      name: brand.name,
      description: brand.intro,
      email: brand.email,
      url: "https://cdtianxin.cn/",
    },
    {
      "@type": "WebSite",
      "@id": "https://cdtianxin.cn/#website",
      name: brand.name,
      alternateName: brand.slogan,
      url: "https://cdtianxin.cn/",
      inLanguage: "zh-CN",
      publisher: { "@id": "https://cdtianxin.cn/#organization" },
      potentialAction: {
        "@type": "SearchAction",
        target: "https://cdtianxin.cn/?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://cdtianxin.cn/#webpage",
      url: "https://cdtianxin.cn/",
      name: "黑料首页 | 栏目导航与站点地图",
      description:
        "黑料社娱乐热点频道导航门户，清晰列出娱乐、影视、综艺、网络热梗等板块与频道分区，并提供站点地图快速定位栏目入口。",
      isPartOf: { "@id": "https://cdtianxin.cn/#website" },
      inLanguage: "zh-CN",
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "首页",
          item: "https://cdtianxin.cn/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "频道导览",
          item: "https://cdtianxin.cn/#channels",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "站点地图",
          item: "https://cdtianxin.cn/#sitemap",
        },
      ],
    },
    {
      "@type": "ItemList",
      name: "黑料社频道分区清单",
      numberOfItems: channels.length,
      itemListElement: channelGroups.map((group, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: group.title,
        description: group.summary,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
  ];

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({ "@context": "https://schema.org", "@graph": graph }),
      }}
    />
  );
}